import React from 'react';
import PropTypes from 'prop-types';
import Segment from "semantic-ui-react/dist/es/elements/Segment/Segment.js";
import { TextInput } from "../../inputs/TextInput";
import { Divider } from "../../elements/Divider";
import { FlexContainer } from "../../layout/FlexContainer";
import { Heading } from "../../typography/Heading";
export var Component = function Component(_ref) {
  var heading = _ref.heading,
      onTextInputChange = _ref.onTextInputChange,
      textInputLabel = _ref.textInputLabel,
      textInputName = _ref.textInputName,
      textInputValue = _ref.textInputValue;
  return React.createElement(Segment, {
    className: "is-input-segment",
    vertical: true
  }, React.createElement(FlexContainer, {
    alignItems: "baseline",
    flexDirection: "column",
    justifyContent: "space-between"
  }, React.createElement(Heading, null, heading), React.createElement(Divider, {
    size: "small"
  }), React.createElement(TextInput, {
    label: textInputLabel,
    name: textInputName,
    onChange: onTextInputChange,
    type: "text",
    value: textInputValue
  })));
};
Component.displayName = 'TextInputSegment';
Component.defaultProps = {
  onTextInputChange: Function.prototype,
  textInputLabel: undefined,
  textInputName: undefined,
  textInputValue: undefined
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  heading: PropTypes.string.isRequired,
  onTextInputChange: PropTypes.func,
  textInputLabel: PropTypes.string,
  textInputName: PropTypes.string,
  textInputValue: PropTypes.string
} : {};